var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"left":"","fill-dot":"","icon":"call_split"}},[_c('span',{attrs:{"slot":"opposite"},slot:"opposite"},[_vm._v(_vm._s(_vm.data.decision))])])}
var staticRenderFns = []

export { render, staticRenderFns }